import React from 'react';
import { useContext } from 'react';
import { AuthContext } from './components/AuthContext';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import Index from './pages/Index';
import Index2 from './pages/Index2';
import Result from './pages/Result';
import Grooming from './pages/Grooming';
import Stuff from './pages/Stuff';
import Staff from './components/Stuff';
import Form from './pages/Form'; 
import EditForm from './components/EditForm';
import SecondPetForm from './pages/SecondPetForm'; //
import Login from './pages/Login';
import Services from './pages/Services';
import Navigation from './components/Navigation';
import GroomingHistory from './pages/GroomingHistory';
import PetForm from './components/PetForm';
import IndexFormPhone from './components/IndexFormPhone';
import IndexFormName from './components/IndexFormName';
import IndexForm from './components/IndexForm';
import CatWalking from './components/CatWalking';
import HistoryGromming from './components/HistoryGromming';
import HistoryGrommingpet from './components/HistoryGrommingpet';

import SignaturePad from './components/SignaturePad';
import PrivateRoute from './components/PrivateRoute';
import OwnerForm2 from './components/OwnerForm2';
import OwnerForm from './components/OwnerForm';
import LastNotes from './components/LastNotes';
import Msg from './components/Messages2';
import LogoutButton from './components/LogoutButton';
import GroomingSchedule from './components/GroomingSchedule';
import Dashboard from './components/Dashboard';
import Customers from './pages/Customers';
import Pets from './pages/Pets';
import DayIndex from './pages/DayIndex';
import StaffHR from "./pages/StaffHR";


import QuickAppointments from "./pages/QuickAppointments";
import Leads from "./pages/Leads";


//import './static/css/index2.css'; HistoryGromming 
import { Navigate } from 'react-router-dom';
import "./apiAuth";
import ProtectedRoute from "./ProtectedRoute";
import ActiveDevices from "./pages/ActiveDevices";
//export default Products; Checkout

function App() {


  const { user } = useContext(AuthContext);
  return (
    <>
      <Navigation />
      <Routes>
<Route path="/active-devices" element={<ActiveDevices />} />
<Route path="/login" element={<Login />} />  
{/*         
      <Route path="/" element={user ? <Index /> : <Navigate to="/singin" />} />
      <Route path="/index" element={user ? <Index2 /> : <Navigate to="/singin" />} />
      <Route path="/messagess" element={user ? <Msg /> : <Navigate to="/singin" />} />
      <Route path="/petscreate" element={user ? <PetForm /> : <Navigate to="/singin" />} />
      <Route path="/signit" element={user ? <SignaturePad /> : <Navigate to="/singin" />} />
      <Route path="/pets" element={user ? <Result /> : <Navigate to="/singin" />} />
      <Route path="/groom-all" element={user ? <Grooming /> : <Navigate to="/singin" />} />
      <Route path="/staff-today" element={user ? <Staff /> : <Navigate to="/singin" />} />
      <Route path="/fill-form" element={user ? <Form /> : <Navigate to="/singin" />} />
      <Route path="/add-appointment" element={user ? <IndexFormPhone /> : <Navigate to="/singin" />} />
      <Route path="/add-appointment-name" element={user ? <IndexFormName /> : <Navigate to="/singin" />} />
      <Route path="/add-appointment/:dateStr/:hour" element={user ? <IndexFormPhone /> : <Navigate to="/singin" />} />
      <Route path="/menu" element={user ? <Navigation /> : <Navigate to="/singin" />} />
      <Route path="/Services" element={user ? <Services /> : <Navigate to="/singin" />} />
      <Route path="/history-groom" element={user ? <HistoryGromming2 /> : <Navigate to="/singin" />} />
      <Route path="/cat_walking" element={user ? <CatWalking /> : <Navigate to="/singin" />} />
      <Route path="/historygroom" element={user ? <HistoryGromming2 /> : <Navigate to="/singin" />} />
      <Route path="/Newgrooming" element={user ? <OwnerForm /> : <Navigate to="/singin" />} />
      <Route path="/example" element={user ? <OwnerForm2 /> : <Navigate to="/singin" />} />
      <Route path="/example2" element={user ? <Dashboard /> : <Navigate to="/singin" />} />
      <Route path="/petgroomingdo" element={user ? <OwnerForm /> : <Navigate to="/singin" />} />
      <Route path="/LastNotes" element={user ? <LastNotes /> : <Navigate to="/singin" />} />
      <Route path="/Customers" element={user ? <Customers /> : <Navigate to="/singin" />} />
        <Route path="/singin" element={<Login />} />

        <Route path="/logout" element={<LogoutButton />} />
        <Route path="/calender" element={<GroomingSchedule />} />
*/}
<Route path="/" element={<Index />} />
<Route path="/index" element={<Index2 />} />
<Route path="/messagess" element={<Msg />} />
<Route path="/petscreate" element={<PetForm />} />
<Route path="/signit" element={<SignaturePad />} />
<Route path="/petsR" element={<Result />} />
<Route path="/groom-all" element={<Grooming />} />
<Route path="/staff-today" element={<Staff />} />
<Route path="/fill-form" element={<Form />} />
<Route path="/add-appointment" element={<IndexFormPhone />} />
<Route path="/add-appointment-name" element={<IndexFormName />} />
<Route path="/add-appointment/:dateStr/:hour" element={<IndexFormPhone />} />
<Route path="/menu" element={<Navigation />} />
<Route path="/Services" element={<Services />} />
<Route path="/cat_walking" element={<CatWalking />} />
<Route path="/historygroom" element={<HistoryGromming />} />
<Route path="/historygroomid" element={<HistoryGrommingpet />} />

<Route path="/quick-appointments" element={<QuickAppointments />} />
<Route path="/leads" element={<Leads />} />


<Route path="/Newgrooming" element={<OwnerForm />} />
<Route path="/example" element={<OwnerForm2 />} />
<Route path="/example2" element={<Dashboard />} />
<Route path="/petgroomingdo" element={<OwnerForm />} />
<Route path="/LastNotes" element={<LastNotes />} />
<Route path="/Customers" element={<Customers />} />
<Route path="/Pets" element={<Pets />} />
<Route path="/Day-appointment" element={<DayIndex />} />
<Route path="/MakeAppointment" element={<Form />} /> 
<Route path="/EditAppointment" element={<EditForm />} />
<Route path="/MakeNewAppointment" element={<SecondPetForm />} /> 
<Route path="/staff" element={<StaffHR />} />



<Route path="/singin" element={<Login />} />
<Route path="/logout" element={<LogoutButton />} />
<Route path="/calender" element={<GroomingSchedule />} />


<Route path="/staff-hr/" element={<StaffHR />} />

      </Routes>
    </>
   
  );
}

export default App;
